<template>
  <div class="vx-row ml-0">
    <div class="p-8 vx-col vx-card" >
    <div><span class="title_card">{{$t('generalSettingMenu.btn5')}}</span></div>
      <div class="mt-4">
        <label class="font-semibold">{{$t('generalSettingMenu.labelBtn4')}}</label>
        <vs-input style="background-color: #F2F2F2;width: 325px;" :disabled="true" v-model="version"></vs-input>
      </div>
      <div class="mt-4">
        <label class="font-semibold">{{$t('generalSettingMenu.labelDate')}}</label>
        <vs-input style="background-color: #F2F2F2;width: 325px;" :disabled="true" v-model="date"></vs-input>
      </div>
      <hr class="mt-4">
      <div class="vx-col">
<!--        <div class="pt-2 pb-2"><span class="font-semibold" style="font-size: 16px">{{$t('generalSettingMenu.changepass')}}</span></div>-->
        <span class="opacity-50">
          {{$t('generalSettingMenu.textBtn5')}}.
        </span>
        <div>
          <span class="opacity-50">
        MST:
        </span>
        </div>
        <div>
          <span class="opacity-50">
          {{$t('fullAddress')}}:
        </span>
        </div>
        <div>
          <span class="opacity-50">
          {{$t('phoneNumber')}}:
        </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Version",
  data(){
    return {
      date:'05/07/2021',
      version:'v.1.2'
    }
  }
}
</script>

<style scoped>
.title_card{
  font-weight: bold;
  font-size: 28px;
}
</style>
